import type { ChangeEventHandler } from "react";
import type { ObservationCategoryModel } from "src/features/Admin/Observations/models";

import { useObservationCategories } from "src/features/Admin/ObservationsCategories/hooks/useObservationCategories";

export type ObservationCategoryTypePickerProps = {
	label: string;

	placeholder?: string;

	helperText?: string | JSX.Element;

	value?: string | number | readonly string[];

	isInvalid?: boolean;

	errorMessage?: string;

	onChange?: ChangeEventHandler<HTMLSelectElement>;
};

const ObservationCategoryTypePicker = ({
	label,
	placeholder,
	helperText,
	value,
	onChange
}: ObservationCategoryTypePickerProps) => {
	const { data: categories } = useObservationCategories();

	const renderCategory = (category: ObservationCategoryModel) => {
		if (category.name === "Undefined") return null;

		return (
			<option key={category.id} value={category.id}>
				{category.name}
			</option>
		);
	};

	return (
		<div>
			<label
				htmlFor="observation-category-picker"
				className="font-heading text-lg font-medium text-foreground mb-1 block"
			>
				{label}
			</label>

			{helperText && typeof helperText === "string" ? (
				<p className="text-[13px] text-muted-foreground mb-4">{helperText}</p>
			) : (
				helperText
			)}

			<select
				id="observation-category-picker"
				className="flex h-10 w-full rounded-md border border-input bg-white px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
				value={value as string | number | readonly string[] | undefined}
				onChange={onChange}
			>
				{placeholder && <option value="">{placeholder}</option>}
				{categories?.map((category) => renderCategory(category))}
			</select>
		</div>
	);
};

export default ObservationCategoryTypePicker;
